import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Activation-Popup.scss';
import { Button } from '@material-ui/core';
import { USER_INACTIVE } from '../../constants/RoleConsts';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ActivationPopupModel = (props) => {
  const {
    activationPopUp,
    user,
    onDeactivate,
    onActivate,
    showImage,
    onActivationPopupActionCancel,
    cancelButtonName,
    okButtonName,
    onOkClick,
  } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onActivationPopupActionCancel();
  };

  const onActionClick = () => {
    if (onOkClick) onOkClick();
    else {
      user.status === 'deactivate' ? onActivate(user) : onDeactivate(user);
    }
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='delete-popup'>
        {showImage && (
          <div className='row d-flex justify-content-center my-3'>
            <img alt={activationPopUp.index} src={activationPopUp.image} className='img' />
          </div>
        )}
        <div className='delete-popup-title'>
          {activationPopUp.title} <br />
          {activationPopUp.name}
        </div>
        <p className={activationPopUp?.descriptionClass || 'delete-popup-description'}>
          {activationPopUp.description}
        </p>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <Button
            variant='outlined'
            size='large'
            color='secondary'
            className='footer-btn'
            onClick={(e) => handleClose()}
          >
            {cancelButtonName ? cancelButtonName : 'Cancel'}
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            className='footer-btn'
            onClick={(e) => onActionClick()}
          >
            {okButtonName
              ? okButtonName
              : user.status === USER_INACTIVE
              ? 'Activate'
              : 'Deactivate'}
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={activationPopUp.status} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default ActivationPopupModel;
